/* eslint-disable */
import income from './income';

export default {
  income,
};
